export default function VerticalSteps({ steps = [] }) {
  return (
    <ol className="relative border-l border-slate-200 pl-6">
      {steps.map((s, i) => (
        <li key={i} className="mb-8 last:mb-0">
          <span className="absolute -left-2.5 mt-1 grid h-5 w-5 place-items-center rounded-full bg-cam-blue ring-4 ring-white">
            {s.icon ? <s.icon className="h-3.5 w-3.5 text-white" aria-hidden /> : null}
          </span>
          <h3 className="text-base md:text-lg font-semibold text-cam-blue">{s.title}</h3>
          <p className="mt-1 text-slate-700">{s.body}</p>
          {s.bullets && (
            <ul className="mt-2 list-disc pl-5 space-y-1 text-slate-700">
              {s.bullets.map((b, j) => (
                <li key={j}>{b}</li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ol>
  );
}
